import { render, staticRenderFns } from "./DeviceLedgerTabList.vue?vue&type=template&id=50a5ccb5&scoped=true"
import script from "./DeviceLedgerTabList.vue?vue&type=script&lang=js"
export * from "./DeviceLedgerTabList.vue?vue&type=script&lang=js"
import style0 from "./DeviceLedgerTabList.vue?vue&type=style&index=0&id=50a5ccb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a5ccb5",
  null
  
)

export default component.exports